import difference from 'lodash/difference';
import uniqBy from 'lodash/uniqBy';

export const getUniqueMarketingCarriers = (bounds = []) => {
  const marketingCarriers = [];

  bounds.map((bound) =>
    bound.segments.map(
      (segment) =>
        segment.marketingCarrier &&
        marketingCarriers.push({
          code: segment.marketingCarrier.code,
          name: segment.marketingCarrier.name,
        }),
    ),
  );

  return uniqBy(marketingCarriers, 'code');
};

export const getUniqueMarketingCarriersFromSegments = (segments) => {
  const marketingCarriers = [];
  segments.map(
    (segment) =>
      segment.marketingCarrier &&
      marketingCarriers.push({
        code: segment.marketingCarrier.code,
        name: segment.marketingCarrier.name,
      }),
  );

  return uniqBy(marketingCarriers, 'code');
};

export const shouldDisplayTaxInformationWithCarriers = (
  carriersToDisplayInTaxBreakdown = '',
  uniqueMarketingCarriers = '',
  zeroTaxesCarriers = '',
) => {
  const carriersCodesToDisplay = carriersToDisplayInTaxBreakdown
    .split(',')
    .map((code) => code.trim());
  const zeroTaxesCarrierCodes = zeroTaxesCarriers.split(',').map((code) => code.trim());
  const uniqueCarrierCodes = uniqueMarketingCarriers.map(({ code }) => code);
  const isOnlyLCC = difference(zeroTaxesCarrierCodes, uniqueCarrierCodes).length === 0;

  if (isOnlyLCC) {
    return false;
  }

  return uniqueCarrierCodes.some((code) => {
    const codeIsIncluded = carriersCodesToDisplay.includes(code);
    const codeIsZeroTaxes = zeroTaxesCarrierCodes.includes(code);

    return codeIsIncluded || codeIsZeroTaxes;
  });
};

export const getMarketingCarrierNamesWithoutZeroTaxes = (carriers, zeroTaxesCarriers = []) =>
  carriers
    .filter((carrier) => !zeroTaxesCarriers.includes(carrier.code))
    .map((carrier) => carrier.name)
    .join(', ');

export const getMarketingCarrierNamesToDisplayInTaxBreakdown = (
  bounds,
  carriersToDisplayInTaxBreakdown,
  zeroTaxesCarriers,
) => {
  const uniqueMarketingCarriers = getUniqueMarketingCarriers(bounds);

  return shouldDisplayTaxInformationWithCarriers(
    carriersToDisplayInTaxBreakdown,
    uniqueMarketingCarriers,
    zeroTaxesCarriers,
  )
    ? getMarketingCarrierNamesWithoutZeroTaxes(uniqueMarketingCarriers, zeroTaxesCarriers)
    : null;
};
